module.exports = __webpack_public_path__ + "static/media/PARENTSQUAD LOGO 5 (2) (3).05c16474.png";